<div class="cityState">
  @if (address) {
  <div class="row g-3" [formGroup]="address">
    @if (!this.isMilitary) {
    <div class="col-sm-12 col-md-12">
      <nh-field
        [attr.aria-required]="addressFieldMandatory"
        id="{{ addressname + '_city' }}"
        [isRow]="true"
        label="{{ 'CITY' | globalTranslate }}"
        [mandatory]="addressFieldMandatory"
      >
        <input
          type="text"
          name="city"
          [attr.aria-label]="'CITY' | globalTranslate"
          formControlName="city"
          [maxlength]="cityMaxLength"
          class="form-control"
          [attr.disabled]="isDisabled ? true : null"
          [required]="addressFieldMandatory"
        />
      </nh-field>
    </div>
    } @if (!this.isMilitary) {
    <div class="col-sm-12 col-md-4">
      <nh-field
        [attr.aria-required]="addressFieldMandatory"
        id="{{ addressname + '_state' }}"
        [isRow]="true"
        label="{{ 'STATE' | globalTranslate }}"
        [mandatory]="addressFieldMandatory"
      >
        <select
          nh
          name="state"
          [attr.aria-label]="'STATE' | globalTranslate"
          [items]="tables.STATE"
          bindLabel="value"
          formControlName="state"
          (change)="onStateChange(address.value.state)"
          [attr.disabled]="isDisabled ? true : null"
          [required]="addressFieldMandatory"
        ></select>
      </nh-field>
    </div>
    } @if (this.isMilitary) {
    <div class="col-sm-12 col-md-4">
      <nh-field
        [attr.aria-required]="false"
        id="{{ addressname + '_addrApoFpo' }}"
        [isRow]="true"
        label="{{ 'APO_FPO' | translate }}"
      >
        <select
          nh
          name="addrApoFpo"
          [attr.aria-label]="'APO_FPO' | translate"
          [items]="tables.MILITARYPOCODES"
          formControlName="addrApoFpo"
        ></select>
      </nh-field>
    </div>
    } @if (this.isMilitary) {
    <div class="col-sm-12 col-md-4">
      <nh-field
        [attr.aria-required]="false"
        id="{{ addressname + '_addrAaAeAp' }}"
        [isRow]="true"
        label="{{ 'AA_AE_AP' | translate }}"
      >
        <select
          nh
          name="addrAaAeAp"
          [attr.aria-label]="'AA_AE_AP' | translate"
          [items]="tables.STATEMILITARY"
          formControlName="addrAaAeAp"
        ></select>
      </nh-field>
    </div>
    }
    <!-- Single zip field (default behavior) -->
    @if (!separateZipFields) {
    <div class="col-sm-12 col-md-4">
      <nh-field
        [attr.aria-required]="addressFieldMandatory"
        id="{{ addressname + '_zip' }}"
        [isRow]="true"
        label="{{ 'ZIP_CODE' | globalTranslate }}"
        [mandatory]="addressFieldMandatory"
      >
        <input
          type="text"
          name="zip"
          [attr.aria-label]="'ZIP_CODE' | globalTranslate"
          formControlName="zip"
          class="form-control"
          mask="00000||00000-0000"
          pattern=""
          placeholder="XXXXX-XXXX"
          [attr.disabled]="isDisabled ? true : null"
          [showMaskTyped]="false"
          [required]="addressFieldMandatory"
          [attr.aria-invalid]="false"
        />
      </nh-field>
    </div>
    }
    <!-- Separate zip fields (for RIDP) -->
    @if (separateZipFields) {
    <div class="col-sm-12 col-md-3">
      <nh-field
        [attr.aria-required]="addressFieldMandatory"
        id="{{ addressname + '_zipCode' }}"
        [isRow]="true"
        label="{{ 'ZIP_CODE' | globalTranslate }}"
        [mandatory]="addressFieldMandatory"
      >
        <input
          type="text"
          name="zipCode"
          [attr.aria-label]="'ZIP_CODE' | globalTranslate"
          formControlName="zipCode"
          class="form-control"
          mask="00000"
          pattern=""
          placeholder="XXXXX"
          [attr.disabled]="isDisabled ? true : null"
          [showMaskTyped]="false"
        />
      </nh-field>
    </div>
    } @if (separateZipFields) {
    <div class="col-sm-12 col-md-4">
      <nh-field
        [attr.aria-required]="false"
        id="{{ addressname + '_zipExtension' }}"
        [isRow]="true"
        label="{{ 'ZIP_EXTENSION' | globalTranslate }}"
        [mandatory]="false"
      >
        <input
          type="text"
          name="zipExtension"
          [attr.aria-label]="'ZIP_EXTENSION' | globalTranslate"
          formControlName="zipExtension"
          class="form-control"
          mask="0000"
          pattern=""
          placeholder="XXXX"
          [attr.disabled]="isDisabled ? true : null"
          [showMaskTyped]="false"
          style="max-width: 255px"
        />
      </nh-field>
    </div>
    } @if (!this.isMilitary && showCounty && !isAssistingPerson && !hideCounty)
    {
    <div class="col-sm-12 col-md-12">
      <nh-field
        [attr.aria-required]="addressFieldMandatory"
        id="{{ addressname + '_county' }}"
        [isRow]="true"
        label="{{ 'COUNTY' | globalTranslate }}"
        [mandatory]="addressFieldMandatory"
      >
        <select
          nh
          name="county"
          [attr.aria-label]="'COUNTY' | globalTranslate"
          [items]="tables.COUNTY"
          formControlName="county"
          [required]="!this.military"
        ></select>
      </nh-field>
    </div>
    }
  </div>
  }
</div>